
import './WorkspaceHeader.css';

const WorkspaceHeader = ({ 
  workspace, 
  sidebarCollapsed, 
  onToggleCollapse,
}) => {
  return (
    <div className="workspace-header">
      <div className="workspace-info">
        {!sidebarCollapsed && (
          <div className="workspace-details">
            <h2 className="workspace-name">{workspace.name}</h2>
            <p className="workspace-plan">{workspace.plan}</p>
          </div>
        )}
        <button 
          className="collapse-btn"
          onClick={onToggleCollapse}
          title={sidebarCollapsed ? 'Collapse sidebar' : 'Expand sidebar'}
        >
          {sidebarCollapsed ? '→' : '←'}
        </button>
      </div>
    </div>
  );
};

export default WorkspaceHeader;
